<!--
 - Author : wanghongling.
 - Date   : 2020/12/23.
 - File   : ycDeal.
 -->

<template>
  <layer title="异常处置情况" titleClass="01" width="326px" padding="15px 20px">
    <div class="progress">
      <div class="progress-item">
        <el-progress type="circle" :stroke-width="4" :width="73" color="#00f417"
            :percentage="setItemProgress(dealInfo.handleCount, dealInfo.total)"
            :format="setItemText(dealInfo, '01')"></el-progress>
        <div class="green-text">已处置</div>
      </div>
      <div class="progress-item">
        <el-progress type="circle" :stroke-width="4" :width="73" color="#cd3d50"
            :percentage="setItemProgress(dealInfo.noHandleCount, dealInfo.total)"
            :format="setItemText(dealInfo)"></el-progress>
        <div class="red-text">未处置</div>
      </div>
      <div class="progress-item">
        <el-progress type="circle" :stroke-width="4" :width="73" color="#00d4f4"
            :percentage="setItemProgress(dealInfo.handleCount, dealInfo.total)"></el-progress>
        <div class="blue-text">处置率</div>
      </div>
    </div>
  </layer>
</template>

<script>
  export default {
    name: 'ycDeal',
    data () {
      return {
        departmentId: '',
        dealInfo: {
          handleCount: 0,
          noHandleCount: 0,
          total: 0
        }
      }
    },
    watch: {
      selectDeptId: {
        handler(cur) {
          this.departmentId = cur
          this.getDeal()
        },
        deep: true
      }
    },
    props: ['selectDeptId'],
    mounted() {
      if(this.departmentId) {
        this.getDeal()
      }
      this.dealWsMsg()
    },
    methods: {
      /**
       * @author wanghongling
       * @createTime 2020/12/24
       * @description websocket监听数据
       */
      dealWsMsg () {
        window.getDealInfo = e => {
          console.log(e, 'websocket监听数据')
          this.getDeal()
        }
      },
      /**
       * @Description:获取处置信息
       * @author wanghongling
       * @createDate 2020/12/24
      */
      getDeal() {
        this.$request.exceptionTodayDeptHandleInfoGet({departmentId: this.departmentId}).then(res => {
          res.total = res.noHandleCount + res.handleCount
          this.dealInfo = res
          console.log('获取处置信息', this.dealInfo)
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:设置进度
       * @author wanghongling
       * @createDate 2020/12/24
      */
      setItemProgress(num, total) {
        return total === 0 ? 0 : parseInt((num / total).toFixed(1) * 100)
      },
      /**
       * @Description:设置文字
       * @author wanghongling
       * @createDate 2020/12/24
      */
      setItemText(item, type) {
        if (type) {
          return () => item.handleCount === 0 ? '0' : item.handleCount
        } else {
          return () => item.noHandleCount === 0 ? '0' : item.noHandleCount
        }

      }
    }
  }
</script>

<style lang="less" scoped>
  .el-progress /deep/ path:first-child {
    stroke: #0d3b6e;
  }
  .el-progress /deep/.el-progress__text{
    color:#fff;
    font-size: 21px !important;
  }
  .progress{
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 10px -10px 0;
    &-item{
      text-align: center;
      font-size: 14px;
    }
    .green-text{
      margin-top: 5px;
      color: #00f417;
    }
    .red-text{
      margin-top: 5px;
      color: #ff6060;
    }
    .blue-text{
      margin-top: 5px;
      color: #18f1ff;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/mingChu/ycDeal.vue